
import React from 'react';
import shape1 from '../../../images/shapes/shape_space_4.svg'
import over_ons from "../../../images/onze_visie/over_ons.jpg";
import Bg3 from "../../../images/shapes/shape_title_under_line.svg";
import shape2 from '../../../images/shapes/shape_space_5.svg';
import {Link} from "react-router-dom";

const OverOns = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <section className="faq_section section_decoration bg-light" style={{paddingBottom: "150px" }}>
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6 order-lg-last">
                        <div className="about_image_2">
                            <div className="image_wrap">
                                <img src={over_ons} width="800px" alt="Praeventor - Onze Visie" />
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="about_content">
                            <div className="heading_block mb-0 text-dark">
                                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>
                                    Wie zijn wij?
                                </div>
                                <h2 className="heading_text">
                                    Over Ons
                                </h2>
                                <p className="heading_description mb-0">
                                    We zijn een team van techneuten, beveiligingsfanaten en probleemoplossers die
                                    samen een veilige digitale wereld willen bouwen. Vanuit onze passie voor cybersecurity
                                    en onze wens om complexe problemen simpel te maken, is Praeventor ontstaan
                                </p>
                                <div style={{ paddingTop: "40px"}}>
                                    <Link onClick={ClickHandler} className="btn btn-primary" to="/about">
                                        <span className="btn_label" data-text="ONTDEK MEER">ONTDEK MEER</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape1} alt="Techco Shape" />
            </div>
            <div className="decoration_item shape_image_1">
                <img src={shape2} alt="Techco Shape Angle" />
            </div>

        </section>
    )
};
export default OverOns;
